import { createContext, useContext, useState } from 'react';

import { Alert, Snackbar } from '@mui/material';

type AppContextType = {
    useToast: (toastOptions: UseToastProps) => void;
};

type UseToastProps = {
    intent: 'error' | 'warning' | 'info' | 'success';
    message?: string;
    duration?: number;
};

const AppContext = createContext<Partial<AppContextType>>({});

export const useAppContext = () => useContext(AppContext);

const defaultToastProps: UseToastProps = {
    intent: 'info',
    duration: 6000,
};

export const AppProvider: React.FC = ({ children }) => {
    const [isToastVisible, setIsToastVisible] = useState(false);
    const [ToastProps, setToastProps] = useState<UseToastProps>(defaultToastProps);

    const useToast = (toastOptions: UseToastProps) => {
        setToastProps(toastOptions);
        setIsToastVisible(true);
    };

    return (
        <AppContext.Provider value={{ useToast }}>
            <Snackbar
                open={isToastVisible}
                autoHideDuration={6000}
                onClose={() => setIsToastVisible(false)}
            >
                <Alert severity={ToastProps.intent}>{ToastProps.message}</Alert>
            </Snackbar>
            {children}
        </AppContext.Provider>
    );
};
